import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormControl } from '@mui/material/FormControl';
import styled from 'styled-components';
import { formLabelTextStyles } from '@famly/mf_theme';
import { Box, createBox } from '@famly/mf_layout_box';
// Callers target `.MuiFormLabel-root` in their own styles to let the label wrap.
const ROOT_CLASS = 'MuiFormLabel-root';
const StyledLabel = styled(createBox({ component: 'label', position: 'relative', padding: 0 })) `
    ${formLabelTextStyles}
`;
export const FormLabel = ({ children, disabled: disabledFromProps, required: requiredFromProps, ...rest }) => {
    // Like MUI, a prop left undefined falls back to the surrounding `FormControl`, which is how the MF
    // `FormControl` greys out its label without passing `disabled`.
    const formControl = useFormControl();
    const disabled = disabledFromProps !== null && disabledFromProps !== void 0 ? disabledFromProps : formControl === null || formControl === void 0 ? void 0 : formControl.disabled;
    const required = requiredFromProps !== null && requiredFromProps !== void 0 ? requiredFromProps : formControl === null || formControl === void 0 ? void 0 : formControl.required;
    return (_jsxs(StyledLabel, { className: ROOT_CLASS, color: disabled ? 'n200' : 'n400', ...rest, children: [children, required ? (
            // Hidden from screen readers, which announce the field's own `required` instead
            _jsx(Box, { component: "span", "aria-hidden": true, color: disabled ? 'n200' : 'r400', children: ' *' })) : null] }));
};
